import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';

// Servicios
import { SettingsService } from 'src/app/core/settings/settings.service';
import { EsabMovementsService } from '../../inventory/esab-movements/esab-movements.service';
import { GlobalFunctionsService } from '../../common/functions/global-functions.service';
import { CalendarService } from '../../configuration/calendar/calendar.service';
import { ReportsService } from '../reports.service';
import { AdjustService } from '../../inventory/adjust/adjust.service';

// Modelos
import { Unit } from '../../common/models/Unit.Model';
import { UserLogin } from '../../common/models/UserLogin.Model';
import { Calendar } from '../../common/models/Calendar.Model';

@Component({
  selector: 'app-rep-equipmentloan',
  templateUrl: './rep-equipmentloan.component.html',
  styleUrls: ['./rep-equipmentloan.component.scss'],
  providers: [DatePipe]
})
export class RepEquipmentloanComponent implements OnInit {

  public inputArgument: string = 'UnitDescription';
  public nodes: Unit[] = [];
  public userLogin: UserLogin;
  public selectedUnit: Unit;
  
  // Manejo de fechas
  public initialDate: string = "";
  public finalDate: string = "";
  public maxDate: string;
  public isValidRange: boolean = true;
  
  public downloading: boolean = false;
  public working: boolean = false;

  constructor(
    private router: Router,
    private services: EsabMovementsService,
    private settings: SettingsService,
    private calServices: CalendarService,
    private reportService: ReportsService,
    private adjustService: AdjustService,
    private globalService: GlobalFunctionsService,
    private datePipe: DatePipe
  ) { 
    // Fecha máxima: Hoy
    this.maxDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd')!;
  }

  async ngOnInit() {
    this.userLogin = this.settings.getUser();
    this.globalService.canOperate();
    this.globalService.hasFSBRPending();

    // Validaciones de negocio (Inventario y Ajuste)
    await this.validateBusinessStatus();
    
    // Carga de nodos iniciales
    this.getUserNodes();
  }

  private async validateBusinessStatus() {
    // Validar Inventario en progreso
    this.calServices.CalendarInventoryInProgress().subscribe((calendar: Calendar[]) => {
      if (calendar && calendar.length === 1) {
        this.globalService.messageToast('Operación no permitida: Inventario físico en curso.', 'warning');
        this.router.navigate(['/home']);
      }
    });

    // Validar Ajuste activo
    try {
      const resp = await this.adjustService.validateAdjustActive(this.userLogin.UnitId).toPromise();
      if (resp && resp.AdjustCode !== '') {
        this.globalService.messageToast('Operación no permitida: Se encuentra en compulsa.', 'warning');
        this.router.navigate(['/home']);
      }
    } catch (e) {
      console.error("Error validando ajuste", e);
    }
  }

  getUserNodes() {
    this.services.getUserNodes(this.userLogin.Org, this.userLogin.Id).toPromise()
      .then((resp: Unit[]) => {
        const todos = new Unit();
        todos.UnitId = 0;
        todos.UnitDescription = "Todos";
        
        this.nodes = [todos, ...resp.filter(x => x.LevelType === 'CEVE')];
        this.selectedUnit = todos;
      });
  }

  // --- Eventos Autocomplete ---
  selectCeVeEvent(value: any) {
    this.selectedUnit = value;
  }

  clearCeVeEvent(value: any) {
    this.selectedUnit = this.nodes[0]; // Regresa a "Todos"
  }

  async btnDowndload() {
    // Validar Unidad
    if (!this.selectedUnit) {
      this.selectedUnit = this.nodes[0];
    }

    // Validar Fechas (Backup manual aunque el componente lo bloquea)
    if (!this.initialDate || !this.finalDate) {
      await this.globalService.messageBimbo('Debe seleccionar un rango de fechas', 'warning', '¡Alerta!');
      return;
    }

    this.downloading = true;
    
    this.reportService.getRepEquipmentLoan(this.selectedUnit.UnitId, this.initialDate, this.finalDate)
      .subscribe({
        next: async (resp: any) => {
          if (!resp) {
            this.downloading = false;
            await this.globalService.messageBimbo('No se ha encontrado información.', 'warning', '¡Alerta!');
            return;
          }

          this.processExcelDownload(resp);
          this.downloading = false;
        },
        error: async (err) => {
          this.downloading = false;
          await this.globalService.messageBimbo('Error al generar el reporte', 'error', '¡Error!');
          console.error(err);
        }
      });
  }

  private processExcelDownload(resp: any) {
    const blob = new Blob([resp], { type: resp.type });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.download = `CEQ-ReporteEquipmentLoan.xlsx`;
    anchor.href = url;
    anchor.click();
    window.URL.revokeObjectURL(url);
  }
}